import { Component, OnInit, ViewChild } from "@angular/core";
import { SpinnerButtonComponent } from "../../../common/components/spinnerButton";
import { ClientService } from "../../../common/services/client.service";
import { LocalizationService } from "../../../common/services/localization";
import { ConfirmModalComponent, DeferredClickEvent } from "../../../common/components/confirmModal";
import { ActivatedRoute, Router } from "@angular/router";

import ValidatorHelper from "../../../common/helpers/validator.helper";
@Component({
    selector: "app-forgot-password",
    template: require("./forgot-password.component.html").default,
    styles: [require("../../../common/styles/index.scss").default, require("../home-page.scss").default],
})
export class ForgotPasswordComponent implements OnInit {
    @ViewChild("spinnerButton") spinnerButton: SpinnerButtonComponent;
    @ViewChild("updateLoginButton") updateLoginButton: SpinnerButtonComponent;
    @ViewChild("confirmErrorModal") confirmErrorModal: ConfirmModalComponent;

    readyToSubmit = false;
    readyToUpdateLogin = false;
    invalidEmailOrPhoneNumber = false;
    errorWhileUpdatingLogin = false;
    success = false;
    submittedOnce = false;
    phoneNumber = "";

    model = {
        emailOrPhoneNumber: { invalid: false, value: "" },
        newPassword: { invalid: false, value: "" },
        confirmPassword: { invalid: false, value: "" },
        verificationCode: { invalid: false, value: "" },
    };

    constructor(
        private _i18n: LocalizationService,
        private client: ClientService,
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            if (params["phone"] || params["email"]) {
                this.model.emailOrPhoneNumber.value = params["phone"] || params["email"] || "";
                this.readyToSubmit = true;
                this.router.navigate(["."], { relativeTo: this.route });
            }
        });
    }

    i18n(key): string {
        return this._i18n.dict()[key];
    }

    submit() {
        const emailOrPhoneNumber = this.model.emailOrPhoneNumber;

        if (
            !ValidatorHelper.isPhoneValid(emailOrPhoneNumber.value) &&
            !ValidatorHelper.assumeIsEmail(emailOrPhoneNumber.value)
        ) {
            emailOrPhoneNumber.invalid = true;
            return;
        } else {
            emailOrPhoneNumber.invalid = false;
        }

        this.invalidEmailOrPhoneNumber = false;
        this.spinnerButton.isSpinning = true;

        let email: string | undefined;
        let phoneNumber: string | undefined;
        if (ValidatorHelper.assumeIsEmail(this.model.emailOrPhoneNumber.value)) {
            email = this.model.emailOrPhoneNumber.value;
        } else {
            phoneNumber = this.model.emailOrPhoneNumber.value;
        }

        this.client.resetPassword(email, phoneNumber).subscribe(
            (res) => {
                email && (this.success = true);
                phoneNumber &&
                    (window.location.href = `/landing/resetPassword?phone=${phoneNumber}&token=${res.verification.token}`);
            },
            (e) => {
                if (e.status === 404) {
                    this.confirmErrorModal.show(
                        this.i18n("alert_not_registered_user_title"),
                        this.i18n(
                            phoneNumber
                                ? "alert_not_registered_phone_number_description"
                                : "alert_not_registered_email_description",
                        ),
                        this.i18n("general_close"),
                        this.i18n(
                            phoneNumber
                                ? "alert_not_registered_phone_number_use_email_action"
                                : "alert_not_registered_email_use_phone_number_action",
                        ),
                        false,
                    );
                } else if (e.status === 429) {
                    this.confirmErrorModal.show(
                        this.i18n("alert_throttle_sms_code_title_2"),
                        this.i18n("alert_throttle_sms_code_description_2"),
                        null,
                        this.i18n("general_ok"),
                        false,
                    );
                } else {
                    this.confirmErrorModal.show(
                        this.i18n("general_title_error"),
                        this.i18n("error_widget_general_error_body"),
                        null,
                        this.i18n("general_ok"),
                        false,
                    );
                }

                this.spinnerButton.isSpinning = false;
            },
        );
    }

    save(event) {}

    formChange(event) {
        this.readyToSubmit = Boolean(this.model.emailOrPhoneNumber.value.length);
    }

    onConfirmErrorClicked(event: DeferredClickEvent) {
        event.success();
        this.invalidEmailOrPhoneNumber = false;
        this.model.emailOrPhoneNumber.value = "";
    }
}
